import React, { Context, createContext, PropsWithChildren, useCallback, useContext, useState } from 'react'
import { callApi, TApiResponse } from '../api'
import { useAuthContext } from '../auth'
import { IKeywords, TKeyword, TKeywordsActions } from '../types'

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

const initialKeywordsState: IKeywords = {
	keywords: [],
	loading: false,
}

const KeywordsContext: Context<{
	keywords: IKeywords
	actions: TKeywordsActions
}> = createContext({
	keywords: initialKeywordsState,
	actions: {
		allLists: (q?: string | null, keywordIds?: number[]) => {},
	},
})

export const KeywordsProvider = (props: PropsWithChildren<{}>) => {
	const { actions: authActions } = useAuthContext()
	const [loading, setLoading] = useState<boolean>(false)
	const [error, setProviderError] = useState<string | null>(null)
	const [keywords, setKeywords] = useState<TKeyword[]>([])

	const fetchKeywords = async (q?: string, keywordIds?: number[]) => {
		setLoading(true)
		const url = q ? `/keywords?q=${q}` : `/keywords`
		const keywordsResponse: TApiResponse = await callApi(url, {
			method: 'POST',
			body: {
				keywordIds,
			},
		})

		const { data } = keywordsResponse.payload

		if (keywordsResponse.ok) {
			setLoading(false)
			setProviderError(null)
			setKeywords(data.keywords)
		} else {
			setLoading(false)
			setProviderError(data.message || 'Cannot get Keywords!')
			if (keywordsResponse.status === 401) {
				authActions.logout()
			}
		}
	}

	const allLists = useCallback(fetchKeywords, [authActions])
	const actions: TKeywordsActions = { allLists }

	return (
		<KeywordsContext.Provider value={{ keywords: { keywords, loading, error }, actions }}>
			{props.children}
		</KeywordsContext.Provider>
	)
}

export const useKeywordsContext: () => {
	keywords: IKeywords
	actions: TKeywordsActions
} = () => {
	return useContext(KeywordsContext)
}
